import * as Types from '../generated/types';

import { gql } from '@apollo/client';
import { PageInfoFragmentDoc } from '../fragments/pageInfo.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AllDealsQueryVariables = Types.Exact<{
  offset?: Types.InputMaybe<Types.Scalars['Int']>;
  before?: Types.InputMaybe<Types.Scalars['String']>;
  after?: Types.InputMaybe<Types.Scalars['String']>;
  first?: Types.InputMaybe<Types.Scalars['Int']>;
  last?: Types.InputMaybe<Types.Scalars['Int']>;
  customer?: Types.InputMaybe<Types.Scalars['Float']>;
  text?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type AllDealsQuery = { __typename?: 'Query', allDeals?: { __typename?: 'DealNodeConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename?: 'DealNodeEdge', cursor: string, node?: { __typename?: 'DealNode', id: string, currency: Types.DealsDealCurrencyChoices, startDate: any, status?: Types.DealsDealStatusChoices | null, npv?: number | null } | null } | null> } | null };


export const AllDealsDocument = gql`
    query AllDeals($offset: Int, $before: String, $after: String, $first: Int, $last: Int, $customer: Float, $text: String) {
  allDeals(
    offset: $offset
    before: $before
    after: $after
    first: $first
    last: $last
    customer: $customer
    text: $text
  ) {
    pageInfo {
      ...PageInfo
    }
    edges {
      node {
        id
        currency
        startDate
        status
        npv
      }
      cursor
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useAllDealsQuery__
 *
 * To run a query within a React component, call `useAllDealsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllDealsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllDealsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      customer: // value for 'customer'
 *      text: // value for 'text'
 *   },
 * });
 */
export function useAllDealsQuery(baseOptions?: Apollo.QueryHookOptions<AllDealsQuery, AllDealsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllDealsQuery, AllDealsQueryVariables>(AllDealsDocument, options);
      }
export function useAllDealsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllDealsQuery, AllDealsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllDealsQuery, AllDealsQueryVariables>(AllDealsDocument, options);
        }
export type AllDealsQueryHookResult = ReturnType<typeof useAllDealsQuery>;
export type AllDealsLazyQueryHookResult = ReturnType<typeof useAllDealsLazyQuery>;
export type AllDealsQueryResult = Apollo.QueryResult<AllDealsQuery, AllDealsQueryVariables>;